import './bootstrap';
import Alpine from 'alpinejs';
import demoGenerator from './components/demo-generator';

function isIgnorableThirdPartyRejection(reason) {
    let message = '';
    if (typeof reason === 'string') {
        message = reason;
    } else if (reason?.message) {
        message = reason.message;
    } else {
        try { message = JSON.stringify(reason) ?? ''; } catch (_) {}
        if (!message) message = reason?.toString?.() ?? '';
    }

    return message.includes('Object Not Found Matching Id:')
        && message.includes('MethodName:update')
        && message.includes('ParamCount:4');
}

window.addEventListener('error', (event) => {
    if (event.message?.includes("window.webkit.messageHandlers")) {
        event.preventDefault();
    }
});

window.addEventListener('unhandledrejection', (event) => {
    if (isIgnorableThirdPartyRejection(event.reason)) {
        event.preventDefault();
    }
});

window.Alpine = Alpine;
window.demoGenerator = demoGenerator;

if (!window._alpineStarted) {
    window._alpineStarted = true;
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => Alpine.start());
    } else {
        Alpine.start();
    }
}
